import React from "react";
import { inject, observer } from "mobx-react";
import classnames from "classnames";
/** Presentation Component */
import HorizontalSpliiter from "component/atoms/horizontalSplitter";

/** Template section */
//import HeaderSection from "pages/viewer-dashboard/section/headerSectionTI";
import HeaderSection from "pages/viewer-dashboard/section/headerSection";
import GridViewportSection from "pages/viewer-dashboard/section/gridViewportSection";
import ToolbarSection from "pages/viewer-dashboard/section/toolbarSection";
import SeriesListSection from "pages/viewer-dashboard/section/seriesListSection";
import DialogSection from "pages/viewer-dashboard/section/dialogSection/index.ts";
import UtilitySection from "pages/viewer-dashboard/section/utilitySection/index.js";
import LoadingSnackbar from "component/atoms/loadingSnackbar";
import AdsSection from "pages/viewer-dashboard/section/AdsSection";
// loadingSnackbarManager disable
import LoadingSnackbarManager from "component/atoms/loadingSnackbar/loadingSnackbarManager";

import Provider from "core/provider/index";
/** File drop/open component */
import Dropzone from "react-dropzone";
import HotKeyMap from "core/hotKeyMap";
import Strings from "constants/strings";
import Config from "config";
import { AdItem } from "types/adDescrition";
import API from "apis";
import "./viewerDashboard.styl";

import BrandImage from "assets/brand/logo.png";
import Icon from "assets/icon";

// const ads = [
//   {
//     type: "adsense",
//     params: {
//       style: {
//         display: "block",
//         width: "300px",
//         height: "600px",
//         margin: "0px auto",
//         marginBottom: "2px",
//       },
//       client: "ca-pub-9578489609030407",
//       slot: "1592868175",
//     },
//   },
//   {
//     type: "adfit",
//     params: {
//       adUnit: "DAN-7wg9TFabgmJe5iY7",
//       width: "300",
//       height: "250",
//     },
//   },
// ];

/**
 * React App main
 *
 * @class App
 * @extends {React.Component}
 */
//@inject("seriesListStore")
@inject("hotkeyStore")
@inject("licenseStore")
@inject("toolbarStore")
@inject("elementViewConfigStore")
@inject("authStore")
@observer
class ViewerDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.initHotkeys();
    this.initAppearance();
  }

  initHotkeys() {
    const { hotkeyStore } = this.props;
    // TODO : 뷰어 버전과같은 지표를 이용해서, 이전 단축키 저장을
    // 활용하거나 지우는 법에 대해 생각해봐야함
    //localStorage.clear();
    const userPreferredHotkeys = JSON.parse(
      localStorage.getItem("hotkey-definitions") || "{}"
    );
    const hasUserPreferences =
      userPreferredHotkeys && Object.keys(userPreferredHotkeys).length > 0;
    if (hasUserPreferences) {
      hotkeyStore.setHotkeys(userPreferredHotkeys);
    } else {
      hotkeyStore.setHotkeys(HotKeyMap.AppConfigGlobalHotKeys.keyMap);
    }

    hotkeyStore.setHandlers(HotKeyMap.AppConfigGlobalHotKeys.handlers);
    hotkeyStore.setDefaultHotkeys(HotKeyMap.AppConfigGlobalHotKeys.keyMap);
  }

  initAppearance() {
    const { elementViewConfigStore } = this.props;
    const loadedAppearance = localStorage.getItem("appearance") || "{}";
    const appearance = JSON.parse(loadedAppearance);
    const hasAppearance = appearance && Object.keys(appearance).length > 0;
    if (hasAppearance) {
      elementViewConfigStore.setConfigAttributes(appearance);
    } else {
      elementViewConfigStore.setConfigAttributes(Config.elementView);
    }
  }

  handleWrapperClick = (e) => {
    // 우측 마우스를 눌렀을때, 발생하는 기본 동작을 막는다.
    e.stopPropagation();
    if (e.isDefaultPrevented()) {
      return;
    }
  };
  componentDidMount() {
    window.onbeforeunload = function (e) {
      var dialogText = "";
      e.returnValue = dialogText;
      return dialogText;
    };

    window.addEventListener("resize", this.handleAppResize);
    window.addEventListener("REQUEST_WADO-URI", this.handleTestRequestWADOURI);
    window.addEventListener("SETUP_CONFIG", this.handleSetupConfig);
  }

  handleTestRequestWADOURI = async (event) => {
    var urls = event.detail;
    for (let i = 0; i < urls.length; i++) {
      urls[i] = "wadouri:" + urls[i];
    }
    Provider.WADOURIProvider.get(urls);
  };

  handleSetupConfig = (event) => {
    const { toolbarStore } = this.props;
    const { splitSeriesOn } = event.detail;
    if (splitSeriesOn === true) {
      //toolbarStore.toogleBatchViewMode(1);
      toolbarStore.setBatchViewMode(true);
    } else {
      toolbarStore.setBatchViewMode(false);
      //toolbarStore.toogleBatchViewMode(-1);
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleAppResize);
    window.removeEventListener(
      "REQUEST_WADO-URI",
      this.handleTestRequestWADOURI
    );
    window.removeEventListener(
      "CONFIG_DOCUMENTATION_URL",
      this.handleConfigDocumentationURL
    );
  }

  handleAppResize(e) {
    if (document.body.clientHeight < Config.APP_MIN_CLIENT_HEIGHT) {
      document.body.style.overflowY = "auto";
    } else {
      document.body.style.overflowY = "hidden";
      document.body.style.overflowX = "hidden";
    }
  }

  /**
   * @method handleContextMenu
   * @description 우 클릭시 발생하는 기본 동작을 막는다.
   * @memberof Viewport
   */
  handleContextMenu = (e) => {
    // 우측 마우스를 눌렀을때, 발생하는 기본 동작을 막는다.
    e.preventDefault();
  };

  handleRequestHide = (notification) => {
    // loadingSnackbarManager disable
    LoadingSnackbarManager.remove(notification);
  };

  handleDICOMFileDrop(acceptedFiles) {
    //const firstfile = [acceptedFiles[0]];
    // Do something with the files

    Provider.DICOMFileProvider(acceptedFiles);
  }

  renderLicenseNotification() {
    return (
      <div className={"licenseNotification"}>
        {Strings.LicenseExpirationMessage.split("\n").map((line, index) => {
          return (
            <span key={index}>
              {line}
              <br />
            </span>
          );
        })}
      </div>
    );
  }
  state = {
    isProfileOpen: false, // 🚀 프로필 팝업 상태 추가
  };

  toggleProfile = () => {
    this.setState((prevState) => ({ isProfileOpen: !prevState.isProfileOpen })); // 🚀 프로필 팝업 토글
  };

  render() {
    const { licenseStore } = this.props;
    const isValid = licenseStore.getValidity();

    const { authStore } = this.props;
    // for dev
    // const isSignedIn = true;
    // for product
    const isSignedIn = authStore.getIsSignedIn();
    const credit = authStore.getCredit();

    let userID = authStore.getUserID();
    if (userID === undefined || userID === null || userID === "") {
      userID = "Anonymous";
    }

    return (
      <React.Fragment>
        {/*** 페이지 전체에(Body 태그) File drop을 허용*/}
        <Dropzone onDropAccepted={this.handleDICOMFileDrop}>
          {({ getRootProps, getInputProps }) => (
            <div
              className="wrapper"
              {...getRootProps({ className: "dropzone" })}
              onContextMenu={this.handleContextMenu}
              onClick={this.handleWrapperClick}
            >
              <input {...getInputProps()} />
              {/**
               * 헤더 영역
               */}
              <HeaderSection
                //logoImage={BrandImage}
                // logoAlt="i-AID lite"
                // userName="HONG GIL DONG"
                ////////////////////////////////////////
                logoImageSrc={BrandImage}
                logoAlt="i-AID lite"
                userName={`${userID}`}
                // userName="HONG GIL DONG"
                userIcon={<Icon.SVGUserIcon />}
                settingIcon={
                  <Icon.SVGSettingIcon onClick={this.toggleProfile} />
                }
              />
              {/* 🚀 프로필 팝업 추가 */}
              {this.state.isProfileOpen && (
                <div className="user_menu">
                  <p className="user_menu_name">{userID}</p>
                  {/* <p className="user_menu_name">HONG GIL DONG</p> */}
                  <ul className="user_menu_list">
                    <li>
                      {" "}
                      <a
                        href={`${process.env.REACT_APP_HOMEPAGE_URL}/profile`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => this.setState({ isProfileOpen: false })}
                      >
                        PROFILE
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a
                        href={`${process.env.REACT_APP_HOMEPAGE_URL}/account`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => this.setState({ isProfileOpen: false })}
                      >
                        ACCOUNT
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a
                        href={`${process.env.REACT_APP_HOMEPAGE_URL}/charge`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => this.setState({ isProfileOpen: false })}
                      >
                        CHARGE
                      </a>
                    </li>
                  </ul>
                  <div className="user_menu_credit">
                    <p className="credit_icon">i</p>
                    <p className="credit_amount">${credit}</p>
                    {/* <p class="credit_amount">1000</p> */}
                    <p>Right</p>
                  </div>
                </div>
              )}
              {/*** 수평 경계선*/}
              <HorizontalSpliiter />
              {/*** 툴바 영역*/}
              <ToolbarSection />
              <div className="wrapperContent">
                <div className="viewerSection">
                  {/**
                   * 시리즈 리스트
                   */}
                  <SeriesListSection />
                  {/**
                   * 뷰어 영역
                   */}
                  <div className="mainContent">
                    <div
                      className={classnames(
                        "viewerMain",
                        !!isValid && "invalidLicense"
                      )}
                      id="viewerMain"
                    >
                      <GridViewportSection />
                      {/* 라이선스 경고 */}
                      {!!!isValid && this.renderLicenseNotification()}
                    </div>
                  </div>
                </div>
                {/* <div className="adsSection">
                  <AdsSection adItems={ads} />
                </div> */}
              </div>
              <DialogSection />
              <UtilitySection />
              <LoadingSnackbar onRequestHide={this.handleRequestHide} />
            </div>
          )}
        </Dropzone>
      </React.Fragment>
    );
  }
}

export default ViewerDashboard;
